// RedirectPage.tsx
import { ExternalLink } from "lucide-react";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const RedirectPage: React.FC = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const destination = queryParams.get("destination");

  if (!destination) {
    return <div>No valid destination provided.</div>;
  }

  const handleContinue = () => {
    window.open(destination, "_blank");
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-[#dde5f0] shadow-md">
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-2xl mx-auto bg-white rounded-lg shadow-lg p-8">
          <div className="flex items-center justify-center mb-6">
            <ExternalLink className="w-12 h-12 text-blue-500 mb-4" />
          </div>

          <h1 className="text-2xl font-bold text-center mb-4">
            Redirecting to External Website
          </h1>

          <p className="text-gray-600 text-center mb-6">
            You are being redirected to an external website. Please note that
            you're leaving WeKruit and our terms and privacy policy will no
            longer apply.
          </p>
          <p className="text-gray-600 text-center mb-6"></p>
          <div className="flex justify-center gap-4">
            <button
              className="px-6 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors"
              onClick={handleContinue}
            >
              Continue
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RedirectPage;
